import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";

// NOT_IN_USE
@Component({
    selector: 'cm-contract-document-upload-consultant',
    templateUrl: './cm-contract-document-upload-consultant.component.html',
    standalone: false
})
export class CmContractDocumentUploadConsultantComponent  implements OnInit, OnChanges {


    @Input() objectIdentifier: ObjectIdentifier;

    constructor() {
    }

    ngOnInit(): void {
    }


    ngOnChanges(changes: SimpleChanges): void {

    }

}
